// extracted by mini-css-extract-plugin
module.exports = {"promotion-form-table":"promotion-form-table-196174c0cc2603e0acb5ff8c5d33f4eb","has-list-add-button":"has-list-add-button-61a924a4502c5854eb71fddc7a3a1305"};